import type {BioIconProps} from './common-types'

export function IconShare({...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...attributes}>
      <path
        d="M17.0312 8.40625H18.4688C18.85 8.40625 19.2156 8.5577 19.4852 8.82728C19.7548 9.09687 19.9062 9.4625 19.9062 9.84375V21.3438C19.9062 21.725 19.7548 22.0906 19.4852 22.3602C19.2156 22.6298 18.85 22.7812 18.4688 22.7812H5.53125C5.15 22.7812 4.78437 22.6298 4.51478 22.3602C4.2452 22.0906 4.09375 21.725 4.09375 21.3438V9.84375C4.09375 9.4625 4.2452 9.09687 4.51478 8.82728C4.78437 8.5577 5.15 8.40625 5.53125 8.40625H6.96875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M12 1.21875V11.2812" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8.40625 4.8125L12 1.21875L15.5938 4.8125" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
